import * as React from "react"

function hexToRgbA(hex) {
    var c;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split('');
        if (c.length === 3) {
            c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = '0x' + c.join('');
        return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',0.4)';
    }
    throw new Error(`Bad Hex: ${hex}`);
}

const IconCircle = (props) => {

    let iconPadding = '25%'
    if (props.padding !== undefined) {
        iconPadding = props.padding
    }
    if(!props.color) return <div></div>;
    return (

        <div className={`circle my-auto ${props.additionalClass}`} style={{ minWidth: props.size, width: props.size, minHeight: props.size, height: props.size, backgroundColor: 'white' }}>
            <div className='circle' style={{ width: '100%', height: '100%', backgroundColor: hexToRgbA(props.color) }}>
                <div className='d-flex justify-content-center' style={{ width: '100%', height: '100%', padding: iconPadding, fill: props.color }}>
                    {props.icon}
                </div>
            </div>
        </div>

    )
}

export default IconCircle;